const lang = {
  title: '個人情報の取り扱い',
  content:
    '<p class="mt-20"><b>1. 事業者の氏名又は名称</b></p>' +
    '<p>株式会社ルクレ</p>' +
    '<p class="mt-20"><b>2. 個人情報保護管理者</b></p>' +
    '<p>部署：管理部</p>' +
    '<p>連絡先：TEL：03-4500-6700 E-mail： privacy@lecre.jp</p>' +
    '<p class="mt-20"><b>3. 個人情報の利用目的</b></p>' +
    '<p>●サービスのお申し込み受付と、当該サービスの実施、運営（本人への連絡を含む）のため</p>' +
    '<p>・本サービスの提供のため</p>' +
    '<p>・本サービスに関連した、各種情報のご案内のため</p>' +
    '<p>●お問い合わせ対応（本人への連絡を含む）のため</p>' +
    '<p>・当社のサービス向上のため</p>' +
    '<p>・本サービスに関連した、各種情報のご案内のため</p>' +
    '<p>●サービスの調査と、お知らせ（本人への連絡を含む）のため</p>' +
    '<p>・当社および当社が認めた者のアンケート等による調査のご案内のため</p>' +
    '<p>・当社および当社が認めた者の広告宣伝のため</p>' +
    '<p class="mt-20"><b>4. 個人情報取扱いの委託</b></p>' +
    '<p>当社は事業運営上、前項利用目的の範囲に限って個人情報を外部に委託することがあります。この場合、個人情報保護水準の高い委託先を選定し、個人情報の適正管理・機密保持についての契約を交わし、適切な管理を実施させます。</p>' +
    '<p class="mt-20"><b>5. 個人情報の開示等の請求</b></p>' +
    '<p>ご本人様は、当社に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、下記の当社問合わせ窓口に申し出ることができます。その際、当社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。</p></br>' +
    '<p>【お問合せ窓口】</p>' +
    '<p>E-mail： privacy@lecre.jp</p>' +
    '<p>〒107-0061 東京都港区北青山1-2-3 青山ビル3F</p>' +
    '<p class="mt-20"><b>6. 個人情報を提供されることの任意性について</b></p>' +
    '<p>ご本人様が当社に個人情報を提供されるかどうかは任意によるものです。 ただし、必要な項目をいただけない場合、適切な対応ができない場合があります。</p>',
  btn_return: '戻る'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/privacy.js